import { FC } from 'react';
import dynamic from 'next/dynamic';
import AccordionBtn from 'components/commercetools-ui/atoms/accordion';
import { hasRichTextContent } from 'helpers/content/hasRichTextContent';
import { useFormat } from 'helpers/hooks/useFormat';
import { AdditionalSection } from '../../product-details/components/additional-section';
import { UIProductContent } from '../../product-details/types';

const RichText = dynamic(() => import('../../../../atoms/rich-text'));

const accordionProps = {
  className: 'border-b-2 border-neutral-400',
  buttonClassName: 'py-16 px-8 font-medium text-16 leading-loose tracking-normal text-primary',
  panelClassName: 'pb-12 px-8',
};

const AdditionalInfo: FC<UIProductContent> = ({
  highlights,
  whatsInTheBox,
  frequentlyAskedQuestions,
}) => {
  const { formatMessage } = useFormat({ name: 'product' });

  return (
    <div className="col-span-12 md:col-span-7">
      {hasRichTextContent(highlights) && (
        <AccordionBtn
          {...accordionProps}
          variant="arrow"
          defaultOpen
          closedSectionTitle={formatMessage({ id: 'product.highlights', defaultMessage: 'Highlights' })}
        >
          <RichText content={highlights} variant="small" />
        </AccordionBtn>
      )}
      {hasRichTextContent(whatsInTheBox) && (
        <AccordionBtn
          {...accordionProps}
          variant="arrow"
          defaultOpen
          closedSectionTitle={formatMessage({ id: 'product.whatsInTheBox', defaultMessage: "What's in the box" })}
        >
          <RichText content={whatsInTheBox} variant="small" />
        </AccordionBtn>
      )}
      {!!frequentlyAskedQuestions?.length && (
        <AdditionalSection title={formatMessage({ id: 'faq', defaultMessage: 'Frequently Asked Questions' })}>
          {frequentlyAskedQuestions.map((faq) => (
            <AccordionBtn
              {...accordionProps}
              variant="plusAndMinus"
              key={faq.id}
              closedSectionTitle={faq.question}
            >
              <RichText content={faq.answer} variant="small" className="text-tertiary" />
            </AccordionBtn>
          ))}
        </AdditionalSection>
      )}
    </div>
  );
};

export default AdditionalInfo;
